import moment from 'moment-timezone';

export const downloadFile = (content, mimetype, name, addTimestamp) => {
  const element = document.createElement('a');
  const file = new Blob([content], {type: mimetype});
  element.href = URL.createObjectURL(file);
  let newName = name;
  if (addTimestamp) {
    const nameParts = name.split('.');
    nameParts.splice(1, 0, moment().format('X'));
    newName = nameParts
      .reduce((prev, cur, idx) => `${prev}${(idx === nameParts.length -1) ? '.' : ''}${cur}`, '');
  }
  element.download = newName;
  element.click();
};

export const importFile = (file, handler) => {
  const reader = new FileReader();
  reader.onloadend = handler;
  reader.readAsText(file);
};
